export default {
  saveCompanyProfile (state, payload) {
    state.financialCompany = payload
  }
}
